import axios from 'axios';

class EventService {

    // baseUrl = "http://localhost:3006";
    baseUrl = "/postgresql";
    

    getEvents() {

        return axios.get(this.baseUrl + '/api/events')
            .then(function (response) {
                // handle success
                return response;
            })
            .catch(function (error) {
                // handle error
                console.error(error);
                throw error;
            })
    }

    getPosibleDuplicateEvents() {

        return axios.get(this.baseUrl + '/api/getPosibleDuplicateEvents')
            .then(function (response) {
                // handle success
                return response;
            })
            .catch(function (error) {
                // handle error
                console.error(error);
                throw error;
            })
    }

    
    duplicateEvents(id) {
        return axios.get(`${this.baseUrl}/api/duplicatesId/${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                console.error(error);
                throw error;
            });
    }

    getDuplicateEvent() {
        return axios.post(this.baseUrl + '/api/duplicates')
            .then(function (response) {
                // handle success
                return response;
            })
            .catch(function (error) {
                // handle error
                console.error(error);
                throw error;
            })
    }

    updateToDuplicate(id) {
        return axios.post(`${this.baseUrl}/api/updateDuplicate/${id}`)
            .then(function (response) {
                // handle success
                return response;
            })
            .catch(function (error) {
                // handle error
                console.error(error);
                throw error;
            })
    }

    updateToNotDuplicate(id) {
        return axios.post(`${this.baseUrl}/api/updateNotDuplicate/${id}`)
            .then(function (response) {
                // handle success
                return response;
            })
            .catch(function (error) {
                // handle error
                console.error(error);
                throw error;
            })
    }

    getEventById(id) {
        return axios.get(`/api/events/${id}`, {
                params: {
                    ID: 12345
                }
            })
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                console.error(error);
                throw error;
            })
    }


    createEvent(data) {
        //console.log(data,"final data");
        return axios.post(this.baseUrl + '/api/events', data)
            .then(function (response) {
                
                return response;
            })
            .catch(function (error) {
                console.error(error);
                throw error;
            });
    }



    reevaluarEvent() {
        return axios.post(this.baseUrl + '/api/reevaluar')
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                console.error(error);
                throw error;
            });




    }



    updateEvent(id, data) {
        return axios.put(`${this.baseUrl}/api/events/${id}`, data)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                console.error(error);
                throw error;
            });
    }


    deleteEvent(id) {
        return axios.delete(`${this.baseUrl}/api/events/${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                console.error(error);
                throw error;
            });
    }


    //PARA LA NUEVA BASE DE DATOS

    getEvents_New() {

        return axios.get(this.baseUrl + '/api/eventsNew')
            .then(function (response) {
                // handle success
                return response;
            })
            .catch(function (error) {
                // handle error
                console.error(error);
                throw error;
            })
    }

    getPosibleDuplicateEvents_New() {

        return axios.get(this.baseUrl + '/api/getPosibleDuplicateEventsNew')
            .then(function (response) {
                // handle success
                return response;
            })
            .catch(function (error) {
                // handle error
                console.error(error);
                throw error;
            })
    }

    
    duplicateEvents_New(id) {
        return axios.get(`${this.baseUrl}/api/duplicatesIdNew/${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                console.error(error);
                throw error;
            });
    }

    getDuplicateEvent_New() {
        return axios.post(this.baseUrl + '/api/duplicatesNew')
            .then(function (response) {
                // handle success
                return response;
            })
            .catch(function (error) {
                // handle error
                console.error(error);
                throw error;
            })
    }

    updateToDuplicate_New(id) {
        return axios.post(`${this.baseUrl}/api/updateDuplicateNew/${id}`)
            .then(function (response) {
                // handle success
                return response;
            })
            .catch(function (error) {
                // handle error
                console.error(error);
                throw error;
            })
    }

    updateToNotDuplicate_New(id) {
        return axios.post(`${this.baseUrl}/api/updateNotDuplicateNew/${id}`)
            .then(function (response) {
                // handle success
                return response;
            })
            .catch(function (error) {
                // handle error
                console.error(error);
                throw error;
            })
    }

    getEventById_New(id) {
        return axios.get(`/api/eventsNew/${id}`, {
                params: {
                    ID: 12345
                }
            })
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                console.error(error);
                throw error;
            })
    }


    createEvent_New(data) {
        return axios.post(this.baseUrl + '/api/eventsNew', data)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                console.error(error);
                //alert(error)
                throw error;
            });
    }

    reevaluarEvent_New() {
        return axios.post(this.baseUrl + '/api/reevaluarNew')
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                console.error(error);
                throw error;
            });
    }



    // updateEvent_New(id, data) {
    //     return axios.put(`${this.baseUrl}/api/eventsNew/${id}`, data)
    //         .then(function (response) {
    //             return response;
    //         })
    //         .catch(function (error) {
    //             console.error(error);
    //             throw error;
    //         });
    // }


    deleteEvent_New(id) {
        return axios.delete(`${this.baseUrl}/api/eventsNew/${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                console.error(error);
                throw error;
            });
    }

    getMunicipalityAdresses(municipality) {

        return axios.get(`${this.baseUrl}/api/getMunicipalityAddresses/${municipality}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                console.error(error);
                throw error;
            });
    }


    logError(data) {
        return axios.post(this.baseUrl + '/api/logError', data)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                console.error(error);
                throw error;
            });
    }

}

export default new EventService();